import { render, staticRenderFns } from "./InvoiceFilters.vue?vue&type=template&id=65632063&"
import script from "./InvoiceFilters.vue?vue&type=script&lang=js&"
export * from "./InvoiceFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports